import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ShareDeclarationsFormDialogComponentData {
  Years: number[];
  DeclarationType: string;
}

@Component({
  selector: 'app-share-declarations-form-dialog',
  templateUrl: './share-declarations-form-dialog.component.html',
  styleUrls: ['./share-declarations-form-dialog.component.scss'],
  standalone: false
})
export class ShareDeclarationsFormDialogComponent {
  dialogRef = inject<MatDialogRef<ShareDeclarationsFormDialogComponent>>(MatDialogRef);
  data = inject<ShareDeclarationsFormDialogComponentData>(MAT_DIALOG_DATA);


  constructor() { }

  onShareButtonClick() {
    this.dialogRef.close(true);
  }

  onCloseButtonClick() {
    this.dialogRef.close(false);
  }
}
